<template lang="pug">
  coming-soon-card
</template>
<script>
import { defineComponent } from '@vue/composition-api'
import ComingSoonCard from '@/components/cards/ComingSoonCard.vue'
export default defineComponent({
  components: { ComingSoonCard }
})
</script>
